import type { PhotoCandid } from '@/api/types/photo'
import type { PlacedImageRefs } from '../types/placed-image-refs'

/**
 * Maps album candid fields to StowedElement `imageElement` identifiers.
 *
 * `imageType: 'Candid'` matches the legacy app's own `IV` attribute for this same photo
 * category — confirmed directly against both a real legacy-authored checkpoint and the
 * backend's StowedElement contract, both of which use `"Candid"`, not `"PHOTO"`. Also required
 * by the Core4 placement tracker.
 */
export function mapCandidToImageRefs(photo: PhotoCandid): PlacedImageRefs {
  return {
    imageId: photo.candidId,
    imageType: 'Candid',
    pezId: '',
  }
}
